import { makeStyles } from "tss-react/mui";
import { MiViewHouse, MiViewIS } from "@miplatform/assets";
import { Box, Typography } from "@mui/material";

export const MiPrintFooter = ({ invoiceTermsAndConditionsHtml, licenses }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.footer}>
      {invoiceTermsAndConditionsHtml && (
        <Box
          className={classes.footerSection}
          dangerouslySetInnerHTML={{
            __html: invoiceTermsAndConditionsHtml,
          }}
        />
      )}
      <Box>
        <Box className={classes.footerBar} />
        <Box className={classes.footerLogosSection}>
          <Box className={classes.column}>
            <img src={MiViewHouse} alt="footer-logo" />
            <Typography className={classes.footerLogoText}>MiBuild</Typography>
          </Box>
          {licenses?.map((license) => (
            <Box key={license.id} className={classes.licenseSection}>
              <Typography fontSize="inherit">{`${license.name} License`}</Typography>
              <Typography className={classes.licenseText} fontSize="inherit">
                {license.number}
              </Typography>
            </Box>
          ))}
          <Box className={classes.column}>
            <Typography className={classes.footerPoweredByText}>
              Powered By
            </Typography>
            <img src={MiViewIS} alt="footer-logo" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  footer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  footerSection: {
    width: "100%",
    fontSize: theme.typography.pxToRem(11),
    fontWeight: theme.fontWeight.regular,
    backgroundColor: theme.palette.grey.light,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.grey.accent}`,
    gap: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
  },
  column: {
    display: "flex",
    flexDirection: "column",
  },
  footerBar: {
    height: 5,
    backgroundColor: "#2C98F0", // COLORS WILL BE CONFIGURED FROM THE BACKEND IN THE FUTURE
    borderTopLeftRadius: theme.spacing(0.75),
    borderTopRightRadius: theme.spacing(0.75),
  },
  footerLogosSection: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundColor: "#38474F", // COLORS WILL BE CONFIGURED FROM THE BACKEND IN THE FUTURE
  },
  footerLogoText: {
    fontWeight: theme.fontWeight.bold,
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(14),
  },
  footerPoweredByText: {
    textAlign: "center",
    fontWeight: theme.fontWeight.regular,
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(10),
  },
  licenseSection: {
    display: "flex",
    flexDirection: "column",
    borderRadius: theme.spacing(0.5),
    fontSize: theme.typography.pxToRem(10),
    padding: theme.spacing(1, 2, 1, 2),
    backgroundColor: theme.palette.grey.accent,
  },
  licenseText: {
    color: theme.palette.grey.main,
  },
}));
